import React, { Component } from "react";
import "antd/dist/antd.css";
import "react-datepicker/dist/react-datepicker.css";
import Routes from "./Routes";
import IdleTime from "./IdleTimer";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
// AntD_Ui_Fix for dropdowns
import { ConfigProvider } from 'antd';
import { getPopupContainer } from './Functions';

class App extends Component {
  constructor() {
    super()
    this.ensureHashInUrl();
  }

  ensureHashInUrl = () => {
    const currentUrl = window.location.href;
    if (!currentUrl.includes('#')) {
      window.location.replace("/");
      window.location.replace(`/app#${window.location.pathname.split("/app").join("")}`);
    }
  };


  // componentDidMount() {
  //   // Dynamically add Google Maps script
  //   const googleMapsScript = document.createElement("script");
  //   googleMapsScript.type = "text/javascript";
  //   googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`;

  //   // Append the script tag to the head of the document
  //   document.head.appendChild(googleMapsScript);
  // }


  render() {
    return (
      <React.Fragment>
        <IdleTime />
        <ConfigProvider getPopupContainer={getPopupContainer}>
        <Routes />
        </ConfigProvider>  
      </React.Fragment>
    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js